import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';

function PaymentSuccess() {
    const [params] = useSearchParams();
    const txnid = params.get('txnid');
    const loanId = params.get('loanId');
    const status = params.get('status');

    return (
        <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#f8fafc', padding: '24px' }}>
            <div style={{ width: 'min(520px, 100%)', background: '#fff', borderRadius: '24px', padding: '32px', boxShadow: '0 18px 40px rgba(15,23,42,0.08)', textAlign: 'center' }}>
                <div style={{ fontSize: '3rem', marginBottom: '12px' }}>✅</div>
                <h1 style={{ margin: '0 0 8px', color: '#0f172a' }}>Payment successful</h1>
                <p style={{ color: '#64748b', marginBottom: '20px' }}>Your repayment request has been received.</p>
                <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '16px', padding: '16px', textAlign: 'left' }}>
                    <p><strong>Loan ID:</strong> {loanId || '--'}</p>
                    <p><strong>Transaction ID:</strong> {txnid || '--'}</p>
                    <p style={{ marginBottom: 0 }}><strong>Status:</strong> {status || 'SUCCESS'}</p>
                </div>
                <Link to="/dashboard" style={{ display: 'inline-block', marginTop: '20px', padding: '12px 20px', borderRadius: '12px', background: '#16a34a', color: '#fff', textDecoration: 'none', fontWeight: 700 }}>
                    Back to Dashboard
                </Link>
            </div>
        </div>
    );
}

export default PaymentSuccess;
